import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AppToolTip, cn, OptionalLabel, Textarea } from '@massilia/ui';
import { useStore } from '@tanstack/react-form';
import { useFieldContext } from '../hooks/use-app-form.js';
import { FieldDisplayValue } from './field-display-value';
import { FieldError } from './field-error';
export default function TextAreaField({ containerClassName, textAreaClassName, label, limit, onDisplayClick, optional, questionToolTip, renderType = 'edit', ...props }) {
    const field = useFieldContext();
    const errors = useStore(field.store, (state) => state.meta.errors);
    if (renderType === 'display') {
        const value = field.state.value ?? '';
        return (_jsx(FieldDisplayValue, { className: containerClassName, label: label, onClick: onDisplayClick, placeholder: props.placeholder ?? '-', value: value }));
    }
    return (_jsxs("div", { className: cn('flex flex-1 flex-col gap-2', containerClassName), children: [_jsxs("div", { className: "flex flex-row gap-2", children: [_jsx(OptionalLabel, { "aria-invalid": errors.length > 0, label: label, optional: optional }), questionToolTip && _jsx(AppToolTip, { text: questionToolTip })] }), _jsx(Textarea, { "aria-invalid": errors.length > 0, className: cn('min-h-20', textAreaClassName), onChange: (e) => {
                    if (optional && e.target.value === '') {
                        field.handleChange(null);
                        return;
                    }
                    field.handleChange(e.target.value);
                }, value: field.state.value ?? '', ...props }), limit && (_jsx("p", { className: "text-noir-text text-sm", children: `${field.state.value?.length ?? 0}/${limit} caractères maximum` })), _jsx(FieldError, { errors: errors })] }));
}
